import { QueryClient } from '@tanstack/react-query'
import { minutesToMilliseconds } from 'date-fns'
import { useState } from 'react'

// singleton instance of the queryClient used on member devices
// most of the time this will be provided by the <QueryClientProvider> in _app.tsx
// but its here for convenience when used by getQueryClient
let _queryClient: QueryClient | undefined

export const createQueryClient = () =>
  new QueryClient({
    defaultOptions: {
      queries: {
        // we want API calls to adhere to a retry "opt-in" policy by default
        // to prevent unnecessary API calls
        retry: false,
        staleTime: minutesToMilliseconds(30),
        refetchOnWindowFocus: false,
        refetchOnReconnect: false,
      },
    },
  })

export const getQueryClient = () => {
  if (!_queryClient) {
    _queryClient = createQueryClient()
  }
  return _queryClient
}

// https://react-query.tanstack.com/guides/ssr#using-hydration
// Create a new QueryClient instance inside of your app, and on an instance ref (or in React state).
// This ensures that data is not shared between different users and requests,
// while still only creating the QueryClient once per component lifecycle.
export const useReactQuery = () => {
  const [queryClient] = useState(() => getQueryClient())
  return queryClient
}
